export const BOOTSTRAP_COLORS = [
  '#fd7e14', // Orange (warm)

  '#0d6efd', // Blue (cool)

  '#ffc107', // Yellow (warm)

  '#20c997', // Teal (cool)

  '#d63384', // Pink (warm)

  '#0dcaf0', // Cyan (cool)

  '#dc3545', // Red (warm)

  '#198754', // Green (cool)

  '#6f42c1', // Purple (cool)

  '#6610f2', // Indigo (cool, last due to similarity)

  '#6c757d' // Gray (neutral, end or separator)
];
